exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom-query-builder .rules-list > :first-child::before {\n  height: 57px;\n  top: -32px;\n  position: relative; }\n\n.btn-view {\n  margin-right: 10px;\n  margin-bottom: 10px; }\n\n.link-detail {\n  cursor: pointer; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Temp/Avemov/Avemov-Angular/src/app/base/customerReports/customer-reports.component.scss
// module id = ../../../../../src/app/base/customerReports/customer-reports.component.scss
// module chunks = main